import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateNotification } from '../services/notificationService';
import { type UpdateNotificationParams } from '../types/notification.types';
import { useAuth } from '@/features/auth/';

export const useNotificationUpdate = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ id, params }: { id: string; params: UpdateNotificationParams }) => {
      if (!user?.id) {
        throw new Error('Usuario no autenticado');
      }

      const updateParams: UpdateNotificationParams = {
        ...params,
        updatedByUserId: user.id
      };

      return updateNotification(id, updateParams);
    },
    onSuccess: () => {
      // Invalidar la caché de notificaciones para forzar una nueva búsqueda
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['notifications-search'] });
    }
  });

  return {
    updateNotification: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError
  };
}; 